export default "__VITE_ASSET__CdTlKuma__"